module.exports = __webpack_public_path__ + "fonts/icomoon.5d8acb7.woff";